var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.00115 11.5902C0.610621 11.9807 0.610621 12.6139 1.00115 13.0044C1.39167 13.3949 2.02483 13.3949 2.41536 13.0044L7.00347 8.41626L11.5919 13.0047C11.9824 13.3952 12.6156 13.3952 13.0061 13.0047C13.3966 12.6141 13.3966 11.981 13.0061 11.5904L8.41769 7.00205L13.0056 2.41414C13.3961 2.02361 13.3961 1.39045 13.0056 0.999925C12.6151 0.6094 11.9819 0.6094 11.5914 0.999925L7.00347 5.58784L2.41585 1.00021C2.02532 0.609684 1.39216 0.609684 1.00163 1.00021C0.611107 1.39073 0.611107 2.0239 1.00163 2.41442L5.58926 7.00205L1.00115 11.5902Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.49c7c8c91c306a84788c1376ec3badc3.svg";
export { ForwardRef as ReactComponent };